<div
  #mask
  class="z-loading-overlay component-overlay component-overlay-enter"
  [class]="styleClass"
  [ngStyle]="{ display: blocked ? 'flex' : 'none', width: this.width, height: this.height }"
>
  <ng-content></ng-content>
</div>
